import React from 'react'
import './Sidenav.css';
import Zikora from '../../Assets/LOGO/ZikoraLogoGreen.png'
import {TbUsers, TbDatabase} from 'react-icons/tb'
import {CgUserAdd, CgHome} from 'react-icons/cg';
import {HiOutlineLogout} from 'react-icons/hi'
import { useNavigate, useLocation } from 'react-router-dom';
import {BiTransfer} from 'react-icons/bi'
import updown from '../../Assets/ICONS/updown.png';
import {TbArrowsUpDown} from 'react-icons/tb'

export const Sidenav = () => {

    const navigate = useNavigate();

    const location = useLocation();

    const auth = JSON.parse(localStorage.getItem('auth'));

    const Logout = () => {
        window.localStorage.clear();
        navigate("/login");
    }

    return (
    <div className='side_nav'>
        
        <div className="inner">

            <div className='logo'>
                <center><img src={Zikora} /></center>
            </div>

            <div className="navs">
                {/* {console.log((auth.user_level))} */}
                <ul>
                    <li onClick={()=>navigate('/welcome')}><span  className={location.pathname!=="/welcome"?"holder":"holder selected"}><span className="icon"><CgHome /></span> <div>Home</div></span></li>

                    {   (auth.user_level === "2" || auth.user_level === 2) ? <></>:
                     <li onClick={()=>navigate('/customers')} ><span className={location.pathname!=="/customers"?"holder":"holder selected"} ><span className="icon"><TbUsers /></span> <div>Customers</div></span></li>
                    }

                    { (auth.user_level === "2" || auth.user_level === 2)  ? <></>:
                        <li onClick={()=>navigate('/existingAccount')}><span className={location.pathname!=="/existingAccount"?"holder":"holder selected"} ><span className="icon"><TbDatabase /></span> <div>Accounts</div></span></li>
                    }
                    { (auth.user_level === "2" || auth.user_level === 2)  ? <></>:
                        <li onClick={()=>navigate('/transfer')}><span className={location.pathname!=="/transfer"?"holder":"holder selected"} ><span className="icon"><TbArrowsUpDown /></span> <div>Transfer</div></span></li>
                    }
                    
                    <li onClick={()=>navigate('/onboard')}><span className={location.pathname!=="/onboard"?"holder":"holder selected"} ><span className="icon"><CgUserAdd /></span> <div>Onboard User</div> </span></li>
                    
                    <li onClick={()=>navigate('/transaction')}><span className={location.pathname!=="/transaction"?"holder":"holder selected"} ><span className="icon"><BiTransfer /></span> <div>Transactions</div> </span></li>
                    
                    <li onClick={()=>navigate('/feedback')}><span className={location.pathname!=="/feedback"?"holder":"holder selected"} ><span className="icon"><img src={updown} width="18px" /></span> <div>Feedback</div> </span></li>
                </ul>

            </div>

            <div className="nav2">
                <ul>
                    <li onClick={Logout}><span className='holder'><span  className="icon"><HiOutlineLogout /></span> <div>Logout</div></span></li>
                </ul>
            </div>


        </div>

    </div>
  )
}
